import React, { useState } from "react";

const Tooltip = ({
  children,
  message,
  position = "top",
  show = true,
  maxWidth = "320px",
  className = "inline-block",
}) => {
  const [visible, setVisible] = useState(false);

  const positionClasses = {
    top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
    bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
    left: "right-full top-1/2 -translate-y-1/2 mr-2",
    right: "left-full top-1/2 -translate-y-1/2 ml-2",
  };

  if (!show || !message) {
    return <>{children}</>;
  }

  const panelStyle = {
    maxWidth,
    width: maxWidth,
  };

  return (
    <div
      className={`relative ${className}`}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div
          className={`pointer-events-none absolute ${positionClasses[position]} z-[200]`}
          style={panelStyle}
          role="tooltip"
        >
          <div
            className="w-full rounded-lg border border-gray-700 bg-gray-900 px-3 py-2.5 text-left text-xs leading-relaxed text-white shadow-xl whitespace-pre-line"
          >
            {message}
            <div
              className={`absolute h-2 w-2 bg-gray-900 rotate-45 ${
                position === "top"
                  ? "bottom-[-4px] left-1/2 -translate-x-1/2"
                  : position === "bottom"
                  ? "top-[-4px] left-1/2 -translate-x-1/2"
                  : position === "left"
                  ? "right-[-4px] top-1/2 -translate-y-1/2"
                  : "left-[-4px] top-1/2 -translate-y-1/2"
              }`}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
